import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MerakiAiComponent } from './meraki-ai.component';

const routes: Routes = [
  {
    path: '',
    component: MerakiAiComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MerakiAiRoutingModule {}
